module.exports = __webpack_public_path__ + "img/analysis_avg.1ab659fb.png";